# usage: <time-zone-picker autocommit="false"></time-zone-picker>
angular.module('rjmNg.directives').directive 'timeZonePicker', [
  () ->
    restrict: 'E'
    templateUrl: "directive.timeZonePicker.html"
    replace: true
    controllerAs: 'view'
    bindToController: true
    scope:
      autocommit: '='
    controller: [
      "logger"
      'clientService'
      'app'
      'timezoneService'
      'notification'
      (logger,clientService,app,timezoneService,notification) ->
        view = @
        cs = null

        @$onInit = ->
          # Get our clientService instance by the clientId
          cs = clientService(app.getClientId())

          cs.fetch().then( (client) ->
            view.client = client

            timezoneService.fetch().then( ({data}) ->
              # Set our array of timezones for the dropdown
              view.timezones = data
              # Set our initial timezone as the client's previous timezone
              view.selected = view.client.clientTimezone
            )
          )

        view.selectThis = (timezone) ->
          conf = true
          if view.autocommit
            conf = confirm("WARNING!!!!\n
              All dates and times that you see in Adobe Commerce Intelligence will 
              be in this time zone, and all dates and times in your data set are
              assumed to already be stored in this time zone. Currently, only 
              data stored in mongodb databases and data from the Push API with 
              a timezone information will be converted to this time zone.
              \n\n
              Are you sure you want to do this?");

            if conf
              view.selected = timezone
              view.updateTimezone()

          else
            view.selected = timezone

        # Update the actual timezone
        view.updateTimezone = () ->
          view.client.clientTimezone = view.selected
          cs.update(view.client)
          logger.log('Time Zone Change', 'TimeZone', 1, 'edit')
          notification.success(
            "Timezone update successful",
            "Your timezone has been successfully updated to #{view.client.clientTimezone}.",
            "global",
            null,
            3
          )

        return view
    ]
]
